import apiClient from './apiClient';

// ============================================================
// Types — matching backend Go models
// ============================================================

export interface FM006 {
  fm006_01: string;        // 庫存分類代號 (PK, max 2 chars)
  fm006_11: string;        // 庫存分類說明 (max 40 chars)
  fm006_21: string;        // 建檔人員代號
  fm006_22: string | null; // 建檔日期
  fm006_91: string;        // 修改人員
  fm006_92: string | null; // 修改日期
  fm006_93: string;        // 修改時間
}

export interface CreateRequest {
  fm006_01: string; // 庫存分類代號
  fm006_11: string; // 庫存分類說明
}

export interface UpdateRequest {
  fm006_11: string; // 庫存分類說明
}

export interface ListResponse {
  data: FM006[];
  total: number;
  page: number;
  size: number;
}

export interface ValidationError {
  field: string;
  message: string;
}

// ============================================================
// API methods
// ============================================================

export const m106Api = {
  async list(page = 1, size = 100, keyword?: string): Promise<ListResponse> {
    const params: Record<string, string | number> = { page, size };
    if (keyword) params.keyword = keyword;
    const res = await apiClient.get('/api/m106', { params });
    return res.data;
  },

  async get(code: string): Promise<FM006> {
    const res = await apiClient.get(`/api/m106/${encodeURIComponent(code)}`);
    return res.data;
  },

  async create(data: CreateRequest): Promise<FM006> {
    const res = await apiClient.post('/api/m106', data);
    return res.data;
  },

  async update(code: string, data: UpdateRequest): Promise<FM006> {
    const res = await apiClient.put(`/api/m106/${encodeURIComponent(code)}`, data);
    return res.data;
  },

  async delete(code: string): Promise<void> {
    await apiClient.delete(`/api/m106/${encodeURIComponent(code)}`);
  },
};
